import { render, staticRenderFns } from "./TipoRelatorio.vue?vue&type=template&id=cfab6516"
import script from "./TipoRelatorio.vue?vue&type=script&lang=js"
export * from "./TipoRelatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports